// views
import UserAvatar from '~/components/user/UserAvatar'
import { Avatar } from 'antd'

// utils
import _ from 'lodash'

const STYLE = {
  marginLeft: '-15px',
  border: '2px solid white',
  position: 'relative',
  borderRadius: '50%',
  display: 'inline-block'
}

export default props => {
  const hasMore = props.charges.length > 10
  const charges = _.take(props.charges, 10)

  const renderMore = (
    <a style={STYLE}>
      <Avatar
        src='/static/icons/dot-more.png'
        size={40}
        style={{ border: '1px solid #ddd' }}
      />
    </a>
  )

  return (
    <div className='text-left'>
      <div style={{ fontSize: '16px', paddingLeft: '5px', marginBottom: '5px' }}>
        <span className='text-primary'>{props.charges.length}</span> 人已充电
      </div>
      <div style={{ paddingLeft: '15px' }}>
        {
          charges.map(charge => (
            <UserAvatar
              user={charge.user}
              size={40}
              key={`${Date.now()}-${charge.id}`}
              style={STYLE}
            />
          ))
        }
        {hasMore && renderMore}
      </div>
    </div>
  )
}
